<template>
    <v-btn
      class="phone-login-button white--text" onclick="window.location.href = '/login'"
    ><v-icon
      left dark
      >
        mdi-cellphone
      </v-icon>
      <div class="vertical-line">
            &nbsp;
        </div>
        <p :style="style['pStyle']">
                {{ text }}
            </p>
    </v-btn>
</template>
  
<script>
  const settings = {
    normal: {
      buttonStyle: {
        margin: '0px',
        padding: '0px'
      },
      pStyle: {
        lineHeight: '10px',
        margin: '0px 26px',
      },
    },
  }
  export default {
    name: 'PhoneLoginButton',
    data () {
      return {
        text: 'Login with Phone'
      }
    },
    computed: {
      style () {
        return settings['normal']
      },
    }
  }
</script>
  

<style>
    button.phone-login-button {
        display: inline-block;
        background-color: #3f51b5 !important;
        padding: 0px;
        word-break: keep-all;
        border-radius: 5px;
        transition-duration: 0s; 
        text-transform: none !important;
        padding: 0 !important;
        /* padding: 0 30px 0 0px; */
        i{
          margin-right: 8px !important;
          margin-left: 8px !important;
        }
    }
    button.phone-login-button * {
        display: inline-block;
        vertical-align: middle;
        padding: 0px;
        border: 0px; 
    }
    button.phone-login-button img {
        max-height: 100%; 
    }
    button.phone-login-button div.vertical-line {
        width: 1px;
        height: 100%;
        margin: 0px !important;
        border-right: 1px solid #174f88 !important; 
    }
    button.phone-login-button p {
        font-family: sans-serif;
        font-weight: bold;
        color: white;
        text-transform: none; 
    }
    button.phone-login-button:hover {
        background-color: #3f51b5 !important; 
    }
    button.phone-login-button:hover div.vertical-line {
        border-right-color: #3f51b5 !important; 
    }
    button.phone-login-button:active {
        background-color: #3f51b5 !important; 
    }
    button.phone-login-button:active div.vertical-line {
      border-right-color: #3f51b5 !important; 
    }
    button.phone-login-button:disabled {
        background-color: #3f51b5 !important; 
    }
    button.phone-login-button:disabled div.vertical-line {
        border-right-color: #3f51b5 !important; 
    }
      
    button.phone-login-button .v-btn__content {
        padding: 0px !important; 
    }
    button.phone-login-button .v-btn__content:before {
        background-color: unset !important; 
    }

  </style>